import { jsPDF } from 'jspdf';

export const generateTransactionReceipt = (data) => {
    const doc = new jsPDF({
        orientation: 'portrait',
        unit: 'mm',
        format: 'a4'
    });

    const pageWidth = doc.internal.pageSize.getWidth();
    const margin = 20;
    const contentWidth = pageWidth - (margin * 2);
    
    // Colores
    const primaryColor = [24, 233, 233]; // #18E9E9
    const darkColor = [30, 30, 30];
    const grayColor = [100, 100, 100];

    // Cargar imagen y generar PDF
    const img = new Image();
    img.src = '/muney_icon.png';
    
    img.onload = () => {
        // Calcular dimensiones manteniendo relación de aspecto
        const maxWidth = 40;  // Ancho máximo deseado en mm
        const maxHeight = 20; // Alto máximo deseado en mm
        
        const ratio = Math.min(maxWidth / img.width, maxHeight / img.height);
        const logoWidth = img.width * ratio;
        const logoHeight = img.height * ratio;

        // Fondo del header
        doc.setFillColor(20, 20, 30);
        doc.rect(0, 0, pageWidth, 50, 'F');

        // Centro vertical del header
        const headerCenter = 25; // Centro del header (50/2)
        const logoY = headerCenter - (logoHeight / 2);

        // Logo centrado verticalmente
        doc.addImage(img, 'PNG', margin, logoY, logoWidth, logoHeight);

        // Título del recibo - alineado al centro del header
        doc.setTextColor(255, 255, 255);
        doc.setFontSize(12);
        doc.setFont('helvetica', 'normal');
        doc.text('Recibo de Transacción', pageWidth - margin, headerCenter - 4, { align: 'right' });
        doc.setFontSize(10);
        doc.text('Partner', pageWidth - margin, headerCenter + 6, { align: 'right' });

        // Línea decorativa
        doc.setDrawColor(...primaryColor);
        doc.setLineWidth(1);
        doc.line(margin, 55, pageWidth - margin, 55);

        // Contenido del recibo
        let yPos = 70;
        const labelX = margin;
        const valueX = margin + 60;
        const lineHeight = 12;

        const fields = [
            { label: 'Beneficiario', value: data.beneficiario },
            { label: 'Banco destino', value: data.bancoDestino },
            { label: 'Número de ID', value: data.numeroId },
            ...(data.numeroTelefono ? [{ label: 'Número de teléfono', value: data.numeroTelefono }] : []),
            { label: 'Monto', value: data.monto },
            { label: 'ID de transacción', value: data.idTransaccion },
            { label: 'Fecha y hora', value: data.fechaHora }
        ];

        fields.forEach((field, index) => {
            // Fondo alternado
            if (index % 2 === 0) {
                doc.setFillColor(245, 245, 250);
                doc.rect(margin - 5, yPos - 6, contentWidth + 10, lineHeight, 'F');
            }

            // Label
            doc.setTextColor(...grayColor);
            doc.setFontSize(10);
            doc.setFont('helvetica', 'normal');
            doc.text(field.label + ':', labelX, yPos);

            // Value
            doc.setTextColor(...darkColor);
            doc.setFontSize(11);
            doc.setFont('helvetica', 'bold');
            doc.text(field.value || '-', valueX, yPos);

            yPos += lineHeight;
        });

        // Línea separadora
        yPos += 10;
        doc.setDrawColor(200, 200, 200);
        doc.setLineWidth(0.5);
        doc.line(margin, yPos, pageWidth - margin, yPos);

        // Footer
        yPos += 15;
        doc.setTextColor(...grayColor);
        doc.setFontSize(9);
        doc.setFont('helvetica', 'normal');
        doc.text('Este recibo es un comprobante de su transacción.', pageWidth / 2, yPos, { align: 'center' });
        doc.text('Conserve este documento para sus registros.', pageWidth / 2, yPos + 5, { align: 'center' });

        // Pie de página con marca de agua
        doc.setTextColor(...primaryColor);
        doc.setFontSize(8);
        doc.text('Powered by Muney', pageWidth / 2, 280, { align: 'center' });

        // Descargar el PDF
        const fileName = `recibo_${data.idTransaccion || 'transaccion'}_${new Date().getTime()}.pdf`;
        try {
            doc.save(fileName);
        } catch (e) {
            console.error('Error al guardar el recibo PDF:', e);
        }
    };

    img.onerror = () => {
        console.error('Error al cargar el logo');
        generatePdfWithoutLogo(doc, data, pageWidth, margin, contentWidth, primaryColor, darkColor, grayColor);
    };
};

// Función fallback si no carga la imagen
const generatePdfWithoutLogo = (doc, data, pageWidth, margin, contentWidth, primaryColor, darkColor, grayColor) => {
    // Fondo del header
    doc.setFillColor(20, 20, 30);
    doc.rect(0, 0, pageWidth, 50, 'F');

    // Texto en lugar del logo
    doc.setTextColor(...primaryColor);
    doc.setFontSize(28);
    doc.setFont('helvetica', 'bold');
    doc.text('muney', margin, 32);

    // Título del recibo
    doc.setTextColor(255, 255, 255);
    doc.setFontSize(12);
    doc.setFont('helvetica', 'normal');
    doc.text('Recibo de Transacción', pageWidth - margin, 28, { align: 'right' });
    doc.setFontSize(10);
    doc.text('Transacción', pageWidth - margin, 36, { align: 'right' });

    // Línea decorativa
    doc.setDrawColor(...primaryColor);
    doc.setLineWidth(1);
    doc.line(margin, 55, pageWidth - margin, 55);

    // Contenido del recibo
    let yPos = 70;
    const labelX = margin;
    const valueX = margin + 60;
    const lineHeight = 12;

    const fields = [
        { label: 'Beneficiario', value: data.beneficiario },
        { label: 'Banco destino', value: data.bancoDestino },
        { label: 'Número de ID', value: data.numeroId },
        ...(data.numeroTelefono ? [{ label: 'Número de teléfono', value: data.numeroTelefono }] : []),
        { label: 'Monto', value: data.monto },
        { label: 'ID de transacción', value: data.idTransaccion },
        { label: 'Fecha y hora', value: data.fechaHora }
    ];

    fields.forEach((field, index) => {
        if (index % 2 === 0) {
            doc.setFillColor(245, 245, 250);
            doc.rect(margin - 5, yPos - 6, contentWidth + 10, lineHeight, 'F');
        }

        doc.setTextColor(...grayColor);
        doc.setFontSize(10);
        doc.setFont('helvetica', 'normal');
        doc.text(field.label + ':', labelX, yPos);

        doc.setTextColor(...darkColor);
        doc.setFontSize(11);
        doc.setFont('helvetica', 'bold');
        doc.text(field.value || '-', valueX, yPos);

        yPos += lineHeight;
    });

    yPos += 10;
    doc.setDrawColor(200, 200, 200);
    doc.setLineWidth(0.5);
    doc.line(margin, yPos, pageWidth - margin, yPos);

    yPos += 15;
    doc.setTextColor(...grayColor);
    doc.setFontSize(9);
    doc.setFont('helvetica', 'normal');
    doc.text('Este recibo es un comprobante de su transacción.', pageWidth / 2, yPos, { align: 'center' });
    doc.text('Conserve este documento para sus registros.', pageWidth / 2, yPos + 5, { align: 'center' });

    doc.setTextColor(...primaryColor);
    doc.setFontSize(8);
    doc.text('Powered by Muney', pageWidth / 2, 280, { align: 'center' });

    const fileName = `recibo_${data.idTransaccion || 'transaccion'}_${new Date().getTime()}.pdf`;
    try {
        doc.save(fileName);
    } catch (e) {
        console.error('Error al guardar el recibo PDF:', e);
    }
};

export default generateTransactionReceipt;